import { render, staticRenderFns } from "./RedpacketSet.vue?vue&type=template&id=80273b9e&scoped=true"
import script from "./RedpacketSet.vue?vue&type=script&lang=js"
export * from "./RedpacketSet.vue?vue&type=script&lang=js"
import style0 from "./RedpacketSet.vue?vue&type=style&index=0&id=80273b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80273b9e",
  null
  
)

export default component.exports